// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2edyQ","colBig":"styles_colBig__T18JT","colSmall":"styles_colSmall__268X2","shopifyNameWrapper":"styles_shopifyNameWrapper__1wawp"};